import React, { useEffect, useState } from 'react'
import contentcopy from '../../asset/images/contentcopy.svg'
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Hni_Admin_Api } from '../../Configuration/API_URL';
import { AESEncryption, ApiResDecrypt } from '../../CommonMethhods/CommonMethods';
import axiosInstance from '../../CommonMethhods/axiosInstance';
const SocialMediaLink = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onBlur', // Validate on blur
  });
  const [createLink, setCreateLink] = useState()
  const [urlSection, setUrlSection] = useState(false)

  const onSubmit = async (data) => {
    console.log(data, "data");
    let payload = {
      "rmCode": data.rmCode
    };
    let encPayload = AESEncryption(payload);

    try {
      const response = await axiosInstance.post(
        `${Hni_Admin_Api.generatesocialmedialink}`,
        encPayload,
      );
      // console.log(response.data, "response");
      const data = await response.data;
      let storeResponse = ApiResDecrypt(data);
      if (storeResponse.status == 0) {
        console.log(storeResponse);
        if (storeResponse.data !== "" || storeResponse.data !== null) {
          setCreateLink(storeResponse.data)
          setUrlSection(true)
        } else {
          setUrlSection(false)
        }

      }
      else {
        toast.error(storeResponse.message)
      }

    } catch (err) {
      toast.error("Something Went Wrong")
    }
  };


  const copyToClipboard = () => {
    navigator.clipboard.writeText(createLink)
      .then(() => {
        toast.success("Link copied to clipboard!")
      })
      .catch(err => {
        toast.error('Failed to copy text: ', err);
      });
  };



  return (
    <div className='social-media'>
      <h2 className='header'>Open Your Demat Account Online and Embark on your Journey to Financial Freedom</h2>
      {/* <div className='social-link'> */}
      <form className='social-link' onSubmit={handleSubmit(onSubmit)}>
        <div className='link-continer'>
          <span className='input-name'>RM Code</span>
          <div className='input-wrapper-social'>
            <input
              className="input-box"
              type="text"
              {...register('rmCode')}
              value={localStorage.getItem("userId")}
            />
          </div>

        </div>
        <button className='link-btn' type="submit" disabled>Generate Link</button>
      </form>
      {/* </div> */}
      {urlSection &&
        <div className='social-link'>
          <div className='generated-link'>
            <span className='link-name'>Generated Link</span>
            <input type="text" className='link-field' value={createLink} disabled />
          </div>
          <button className='copy-btn' onClick={copyToClipboard}>
            <img src={contentcopy} alt="contentcopy" height={"20"} width={"20px"} />
            Copy Link
          </button>
        </div>
      }

    </div>
  )
}

export default SocialMediaLink;